
<search
  ref="search"
  class="sales-history-search"
  source="salesarchive"
  sort="date"
  v-bind="$attrs"
  :placeholder="placeholder"
  v-on="$listeners"
>
  <template #default="slotProps">
    <sales-list-item split :item="slotProps.item">
      <verified-icon v-if="slotProps.item.cardId" />
    </sales-list-item>
  </template>
</search>
